import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Arrange, Pill } from "@aviary";
import { l } from "@shared/locales/i18n";
import { Size } from "@shared/types/sizes";

const ProductFilledOnSiteTag: FC = ({ ...rest }) => {
  const { t } = useTranslation();

  return (
    <Arrange justify="center">
      <Pill isSize={Size.SMALL} isColor="highlight" {...rest}>
        {t(l.products.FilledOnSite)}
      </Pill>
    </Arrange>
  );
};

export { ProductFilledOnSiteTag };
